const PAGES_ROUTE = '/pages';
export const NEW_PAGE_ROUTE = `${PAGES_ROUTE}/new`;
export const EDIT_PAGE_ROUTE = `${PAGES_ROUTE}/:id`;

export const PAGES_ROUTES = {
  root: PAGES_ROUTE,
  edit: NEW_PAGE_ROUTE,
  new: EDIT_PAGE_ROUTE
};
